import { Component, computed, HostListener, inject, signal } from '@angular/core';
import { GameService } from '@core/game/game.service';
import { Vector2 } from '@typings/vectors';

@Component({
  selector: 'app-game-container',
  imports: [],
  templateUrl: './game-container.component.html',
  styleUrl: './game-container.component.css',
})
export class GameContainerComponent {
  readonly _gameService = inject(GameService);

  aspectRatio = signal(16 / 9);
  windowSize = signal<Vector2>([0, 0] as Vector2);
  inlineOrBlockMargin = computed(() => {
    const wantedHeight = this.windowSize()[0] / this.aspectRatio();
    if (wantedHeight > this.windowSize()[1]) {
      return 'inline' as const;
    } else return 'block' as const;
  });

  constructor() {
    this.updateWindowSize();
  }

  @HostListener('window:resize', [])
  updateWindowSize() {
    this.windowSize.set([window.innerWidth, window.innerHeight] as Vector2);
  }
}
